import React, { useCallback, useEffect } from "react";
import { Route, Switch, useParams, useRouteMatch } from "react-router-dom";
import { EventPageContainer } from "../events/EventPageContainer";
import EventDetailCard from "../events/eventDetails/views/EventDetailCard";
import EventParticipants from "../events/eventDetails/views/EventParticipants";
import ParticipantForm from "../events/eventDetails/components/ParticipantForm";
import SubEvents from "../events/eventDetails/views/SubEvents";
import ConsoleHelper from "../utils/logger";
import { SubEventNavigation } from "./SubEventNavigation";
import { useDispatch } from "react-redux";
import allActions from "../actions/allActions";
import { EventParamTypes } from "../types/types";

export const EventNavigation: React.FC = () => {
  let { path } = useRouteMatch();
  const { id } = useParams<EventParamTypes>();
  const dispatch = useDispatch();

  const getEventDetails = useCallback(() => {
    dispatch(allActions.eventActions.startGetEventDetails(id));
  }, [id, dispatch]);

  const getAllEvents = useCallback(() => {
    dispatch(allActions.eventActions.getAllEvents({ date: "0", limit: "100" }));
  }, [dispatch]);

  const getParticipants = useCallback(() => {
    dispatch(allActions.participantActions.getParticipants(id));
  }, [id, dispatch]);

  useEffect(() => {
    getAllEvents();
  }, [getAllEvents]);

  useEffect(() => {
    getEventDetails();
  }, [getEventDetails]);

  useEffect(() => {
    getParticipants();
  }, [getParticipants]);

  ConsoleHelper(path);
  return (
    <Switch>
      <Route exact path={path} render={() => <EventPageContainer />} />
      <Route exact path={`${path}/subevents`} render={() => <SubEvents />} />
      <Route path={`${path}/details`} render={() => <EventDetailCard />} />
      <Route
        path={`${path}/participants`}
        render={() => <EventParticipants />}
      />
      <Route
        path={`/${path}/participants/:participantId`}
        render={() => <ParticipantForm />}
      />
      <Route
        path={`${path}/subevents/:subEventId`}
        render={() => <SubEventNavigation />}
      />
    </Switch>
  );
};

export default EventNavigation;
